import request from '@/utils/request'

export function getCropInfo(params) {
    return request({
        url: `/dingTalk/nb/config`,
        method: 'get',
        params
    })
}

export function authenticate(data) {
    return request({
        url: `/dingTalk/nb/authenticate`,
        method: 'post',
        data
    })
}
export function getNbData(params) {
    return request({
        url: `/dingTalk/nb/getNbData`,
        method: 'get',
        params
    })
}
export function get2024NbData(params) {
    return request({
        url: `/dingTalk/nb/2024/getNbData`,
        method: 'get',
        params
    })
}
export function get2025NbData(params) {
    return request({
        url: `/dingTalk/nb/2025/getNbData`,
        method: 'get',
        params
    })
}
export function sign(params) {
    return request({
        url: `/dingTalk/nb/sign`,
        method: 'get',
        params
    })
}

// ==================== 待办相关接口 ====================

/** 创建待办 */
export function createTodo(data) {
    return request({
        url: `/learnToDo/create`,
        method: 'post',
        data
    })
}

/** 查询待办详情 */
export function getTodoDetail(taskId) {
    return request({
        url: `/learnToDo/detail/${taskId}`,
        method: 'get'
    })
}

/** 查询已创建的待办列表 */
export function getCreatedTodoList() {
    return request({
        url: `/learnToDo/createdList`,
        method: 'get'
    })
}

/** 查询待办列表（所有渠道：ORG/YIDA/OA） */
export function getTodoList(userId) {
    return request({
        url: `/learnToDo/todo/${userId}`,
        method: 'get'
    })
}

export default { getCropInfo, authenticate, getNbData, sign, createTodo, getTodoDetail, getCreatedTodoList, getTodoList }
